import * as React from 'react';

import type {SalesAutomationStepTemplate as SalesAutomationStepTemplateFragment} from 'nutshell-graphql-types';

import {TodoTemplateCard} from './todo-template-card';

type Props = {
    index: number;
    isHidden: boolean;
    stepTemplate: SalesAutomationStepTemplateFragment;
    isDragDisabled: boolean;
};

export function StepTemplateCard(props: Props) {
    return (
        <TodoTemplateCard
            type='stepTemplates'
            index={props.index}
            isHidden={props.isHidden}
            parentId={props.stepTemplate.stage.id}
            todoTemplate={props.stepTemplate}
            isDragDisabled={props.isDragDisabled}
            isDraggable={true}
        />
    );
}
